import React, { useState, useEffect } from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { useNavigate } from "react-router-dom";
import { ACCESS_TOKEN, REFRESH_TOKEN } from "../constants";
import api from "../api";
import { useTranslation } from '../LanguageContext';
// Sadece client ID, ve sadece .env'den. Gizli bir değer değil — Google butonu
// onu tarayıcıya zaten yazıyor — ama diğer REACT_APP_* değişkenleri gibi build
// zamanında gömülüyor: değiştirince `npm run build` almadan hiçbir şey olmaz.
//
// Client *secret* buraya hiçbir koşulda girmez: REACT_APP_ ile başlayan her
// değişken bundle'a düz metin olarak gider. İhtiyaç da yok; bu akış Google'ın
// imzaladığı ID token'ı sunucuya yollamaktan ibaret, secret'ı gerektiren tek
// yer yok. Backend tarafta da yalnızca GOOGLE_CLIENT_ID okunuyor (token'ın
// audience'ını doğrulamak için), secret env_prod.txt'te sunucuda kalıyor.
const clientId = (process.env.REACT_APP_GOOGLE_CLIENT_ID || '').trim();

if (!clientId && process.env.NODE_ENV === 'development') {
  console.warn(
    'REACT_APP_GOOGLE_CLIENT_ID tanımlı değil — "Google ile giriş" butonu gizlendi.'
  );
}

const handleSucces = async (token, navigate, method, t) => {
  try {
    const res = await api.post("/api/auth/google/", { token, method });
    localStorage.setItem(ACCESS_TOKEN, res.data.access);
    localStorage.setItem(REFRESH_TOKEN, res.data.refresh);

    navigate("/profile")
  }
  catch (error) {
    alert(error.response.data);
  }
};
const onFailure = (t) => {
  alert(t('login.errorAlert'));
};

function GoogleSignIn(method) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [containerWidth, setContainerWidth] = useState(400);

  useEffect(() => {
    const updateWidth = () => {
      // 80px is the total horizontal padding (32px from parent px-4 + 48px from card p-6)
      const safeWidth = window.innerWidth - 80;
      setContainerWidth(Math.min(400, Math.max(200, safeWidth)));
    };

    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  const onSuccess = async (credentialResponse) => {
    const token = credentialResponse.credential;
    handleSucces(token, navigate, method, t);
  };

  // Kimlik yoksa buton hiç basılmıyor: clientId'siz bir GoogleOAuthProvider,
  // Google'ın script'ini hataya sokan boş bir düğme çiziyor. Parolayla giriş
  // formunun kalanı çalışmaya devam etsin.
  if (!clientId) return null;

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <div className="google-btn-wrap" style={{ width: '100%', marginTop: '16px', display: 'flex', justifyContent: 'center' }}>
        <GoogleLogin
          onSuccess={onSuccess}
          onError={() => onFailure(t)}
          width={containerWidth.toString()}
          shape="pill"
          itp_support={false}
          useOneTap={false}
          auto_select={false}
        />
      </div>
    </GoogleOAuthProvider>
  );
}

export default GoogleSignIn;